import { redirect } from '@tanstack/react-router';
import { getUserStore } from '@/entities/user';

type AuthGuardRouteProps = {
  isPrivate?: boolean;
};

export function authGuardRoute({ isPrivate = false }: AuthGuardRouteProps) {
  const user = getUserStore();
  const isAuthenticated = !!user?.uuid;

  if (!isAuthenticated && isPrivate) {
    throw redirect({
      to: '/sign-in',
      replace: true,
    });
  }

  if (isAuthenticated && !isPrivate) {
    throw redirect({
      to: '/',
      replace: true,
    });
  }
}
